import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Banner, Navigation } from './Profile.styles.js';
import AvatarCard from "@components/AvatarCard/AvatarCard.js";
import Container from "@components/Container/Container.js";
import login from '@assets/images/login.jpg';
import { Button, Card, Descriptions, Divider, Tabs } from 'antd';
import _ from "lodash";
import notification2 from "@components/Notification2";
import { api } from "@redux/api";
import { EditOutlined, UnlockOutlined } from "@ant-design/icons";
import UserProfileForm from './UserProfileForm.js';

const { TabPane } = Tabs;

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
        }
    }

    componentDidMount() {
        let columns = [
            {
                title: 'Id',
                dataIndex: 'id',
                width: '10%',
            },
            {
                title: 'Username',
                dataIndex: 'username',
                width: '10%',
                editable: true,
            },
        ]
        this.setState({
            columns
        })
    }

    handleResetPassword = (e) => {

        let email = _.get(this.props.auth, 'email')

        this.setState({
            isLoading: true
        })
        api.forgetpassword(email).then(res => {
            this.setState({
                isLoading: false
            })
            return notification2['success']({
                message: 'Success',
                description: 'Password reset successfully, please check your email', placement: 'topLeft'
            });
        })

    }

    render() {

        return (
            <div>
                <Banner
                    className="profile-banner"
                    style={{ backgroundImage: `url(${login})` }}
                >
                    <Container className="container">
                        {/* <AvatarCard
                            avatar={this.props.auth.image}
                            name={this.props.auth.username}
                            username={''}
                        /> */}
                    </Container>
                </Banner>

                <Navigation className="navigation">
                    <Container className="container">
                        <Tabs defaultActiveKey="1" centered>
                            <TabPane tab="Personal Settings" key="1">
                                <Card bordered={false}
                                    title={
                                        <div className='flex justify-between'>
                                            <Button type='primary' key="1" onClick={this.handleResetPassword}
                                                icon={<UnlockOutlined />}> ResetPassword</Button>
                                        </div>
                                    }>
                                        <UserProfileForm />
                                </Card>
                            </TabPane>
                        </Tabs>
                    </Container>
                </Navigation>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.Auth,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile);
